<app-loading *ngIf="!flagLoaded" class="m-5"></app-loading>

<div class="custom-header">
  <div class="container-fluid">
    <div class="header-content text-center">
      <div *ngIf="flagLoaded" class="solicitud-info">
        Solicitud - {{ solicitud.lastState.numberState | estadosPipe }}
      </div>
    </div>
  </div>
  <button class="close-app-btn" (click)="closeModal()" aria-label="Cerrar">
    <i class="fas fa-times-circle"></i>
  </button>
</div>

<div class="container-fluid main-container" *ngIf="flagLoaded">
  <div class="row">
    <div class="col-md-6 left-column d-flex flex-column">
      <mat-expansion-panel [expanded]="true" [disabled]="true" class="compact-panel">
        <mat-expansion-panel-header class="clasico">
          <mat-panel-title class="card-title-large">Estado del Beneficiario</mat-panel-title>
        </mat-expansion-panel-header>
        <app-ofertas-estado-detalle 
          [solicitud]="solicitud" 
          [usuario]="usuario" 
          [beneficiario]="beneficiario"
          [nombrePais]="nombrePais" 
          [estadoDocumentacion]="estadoDocumentacion">
        </app-ofertas-estado-detalle>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="true" [disabled]="true" class="compact-panel">
        <mat-expansion-panel-header class="clasico">
          <mat-panel-title class="card-title-large">Documentación - Fotos</mat-panel-title>
        </mat-expansion-panel-header>
        <mat-card-content>
          <button *ngIf="imgs.length > 0" class="full-width-btn" (click)="openGalleryModal()">
            Ver Galería
          </button>
          <p *ngIf="!imgs.length" class="no-media-msg">No se encontraron fotos</p>
        </mat-card-content>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="true" [disabled]="true" class="compact-panel">
        <mat-expansion-panel-header class="clasico">
          <mat-panel-title class="card-title-large">Documentación - Archivos</mat-panel-title>
        </mat-expansion-panel-header>
        <mat-card-content>
          <app-ofertas-files *ngIf="files.length > 0" [files]="files" [usuario]="usuario"></app-ofertas-files>
          <p *ngIf="!files.length" class="no-media-msg">No se encontraron archivos</p>
        </mat-card-content>
      </mat-expansion-panel>

    </div>

    <div class="col-md-6 right-column d-flex flex-column">

      <mat-expansion-panel [expanded]="true" [disabled]="true" class="compact-panel">
        <mat-expansion-panel-header class="clasico">
          <mat-panel-title class="card-title-large">Estado de la Solicitud</mat-panel-title>
        </mat-expansion-panel-header>
        <mat-card-content>
          <app-stepper [stepperSet]="solicitud.lastState.numberState" [vertical]="false"></app-stepper>
        </mat-card-content>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="true" [disabled]="true" class="compact-panel">
        <mat-expansion-panel-header class="clasico">
          <mat-panel-title>Tratar Solicitud</mat-panel-title>
        </mat-expansion-panel-header>
      
        <div class="my-carousel-container">
          <button class="my-carousel-arrow prev" 
                  (click)="previousSlide()" 
                  [disabled]="currentSlide === 0"
                  matTooltip="Sección anterior">
            <i class="fas fa-chevron-left"></i>
          </button>
          
          <div #carousel class="my-carousel-track">
            <!-- Revisión -->
            <div class="my-carousel-slide" [class.active]="currentSlide === 0">
              <mat-card>
                <mat-card-header>
                  <mat-card-title>Revisión</mat-card-title>
                  <mat-card-subtitle>
                    Si las autorizaciones y/o documentación presentadas por el afiliado están incompletas o falta documentación necesaria para poder autorizarlas, envíe una observación para que el afiliado pueda completar su solicitud adjuntando la documentación faltante. De esta manera, se podrá continuar con el proceso de solicitud.
                  </mat-card-subtitle>
                </mat-card-header>
                <mat-card-actions>
                  <mat-slide-toggle *ngIf="activarEnRevision" [(ngModel)]="isCheckedEnRevision">
                    Active la opción enviar una observación al afiliado con respecto a su documentación.
                  </mat-slide-toggle>
                  <section *ngIf="isCheckedEnRevision">
                    <br>
                    <mat-form-field class="motivo-text-area" mat-focus-on-activation>
                      <mat-label>Observaciones</mat-label>
                      <textarea matInput
                                placeholder="Incluya las observaciones pertinentes para informar al afiliado"
                                mat-autosize="true"
                                [(ngModel)]="motivoRevision"
                                (input)="habilitarBotonObservaciones(motivoRevision)">
                      </textarea>
                    </mat-form-field>
                    <br>
                    <button *ngIf="activarEnRevision"
                            (click)="actualizarEstadoSolicitud(solicitud._id, iAppOfertas.estado_2.number, false, iAppOfertas.estado_2.name, true, motivoRevision)"
                            mat-raised-button
                            color="success"
                            [disabled]="!habilitarEnviarObservacion">
                      Enviar Observación
                    </button>
                    <button *ngIf="!activarEnRevision" mat-raised-button color="accent" disabled>
                      Enviar Observación
                    </button>
                  </section>
                </mat-card-actions>
              </mat-card>
            </div>

            <div class="my-carousel-slide" [class.active]="currentSlide === 1">
              <mat-card>
                <mat-card-header>
                  <mat-card-title>En Espera</mat-card-title>
                  <mat-card-subtitle>
                    Marque la solicitud como "En Espera" si requiere una acción externa o si el proceso debe pausarse temporalmente. El afiliado no recibirá notificaciones de estado mientras la solicitud esté en este estado.
                  </mat-card-subtitle>
                </mat-card-header>
                <mat-card-actions>
                  <mat-slide-toggle *ngIf="activarEnEspera" [(ngModel)]="isCheckedEnEspera">
                    Active la opción para poner la solicitud En Espera
                  </mat-slide-toggle>
                  <section *ngIf="isCheckedEnEspera">
                    <mat-form-field class="motivo-text-area" mat-focus-on-activation>
                      <mat-label>Motivo de Puesta en Espera (Opcional)</mat-label>
                      <textarea matInput
                                placeholder="Escriba el motivo por el cual la solicitud se pone en espera"
                                mat-autosize="true"
                                [(ngModel)]="motivoEnEspera">
                      </textarea>
                    </mat-form-field>
                    <br>
                    <button (click)="actualizarEstadoSolicitud(solicitud._id, iAppOfertas.estado_6.number, false, iAppOfertas.estado_6.name, true, motivoEnEspera)"
                            mat-raised-button
                            color="primary"
                            [disabled]="!isCheckedEnEspera"> 
                            Poner En Espera
                    </button>
                  </section>
                </mat-card-actions>
              </mat-card>
            </div>
            
            <!-- Aprobación -->
            <div class="my-carousel-slide" [class.active]="currentSlide === 2">
              <mat-card>
                <mat-card-header>
                  <mat-card-title>Aprobar</mat-card-title>
                  <mat-card-subtitle>
                    Las autorizaciones y documentación presentadas están correctos. Recuerde que al APROBAR, al afiliado se le notificará que su autorización fue aprobada.
                  </mat-card-subtitle>
                </mat-card-header>
                <mat-card-actions>
                  <mat-slide-toggle *ngIf="activarAprobar" [(ngModel)]="isCheckedAprobar">
                    Active la opción para aprobar
                  </mat-slide-toggle>
                  <section *ngIf="isCheckedAprobar" class="section">
                    <mat-slide-toggle [(ngModel)]="requiereArchivo">
                      Adjuntar archivo (opcional)
                    </mat-slide-toggle>
                    <section *ngIf="requiereArchivo">
                      <br>
                      <p>Por favor, adjunte el archivo PDF necesario para la aprobación de la solicitud.</p>
                      <div class="file-upload" [class.active]="isActive">
                        <div class="file-select">
                          <div class="file-select-button" id="fileName" (click)="fileInput.click()">
                            Seleccione un archivo PDF
                          </div>
                          <div class="file-select-name" id="noFile">
                            {{ selectedFileName || 'No se seleccionó ningún archivo...' }}
                          </div>
                          <input type="file" name="chooseFile" id="chooseFile" #fileInput accept="application/pdf" (change)="onFileSelected($event)">
                        </div>
                      </div>
                    </section>
                    <br>
                    <button (click)="aprobarSolicitud()"
                            mat-raised-button
                            color="success"
                            [disabled]="requiereArchivo && flagDisableButtonApprove"
                            [ngClass]="{'custom-disabled': requiereArchivo && flagDisableButtonApprove}">
                      Aprobar Trámite
                    </button>
                  </section>
                </mat-card-actions>
              </mat-card>
            </div>
            
            <!-- Anular -->
            <div class="my-carousel-slide" [class.active]="currentSlide === 3">
              <mat-card>
                <mat-card-header>
                  <mat-card-title>Anular</mat-card-title>
                  <mat-card-subtitle>
                    <div class="alert alert-danger" role="alert">
                      <h5 class="alert-heading">¡Importante!</h5>
                      <p>
                        Al <strong>Anular</strong> una solicitud, el afiliado tendrá que reenviar la autorización y su documentación nuevamente.
                      </p>
                    </div>
                  </mat-card-subtitle>
                </mat-card-header>
                <mat-card-actions>
                  <mat-slide-toggle *ngIf="activarRechazar" [(ngModel)]="isCheckedRechazar">
                    Active la opción para Anular
                  </mat-slide-toggle>
                  <section *ngIf="isCheckedRechazar">
                    <mat-form-field class="motivo-text-area" mat-focus-on-activation>
                      <mat-label>Motivo de Rechazo</mat-label>
                      <textarea matInput
                                placeholder="Escriba el motivo por el cual se rechaza la solicitud..."
                                mat-autosize="true"
                                [(ngModel)]="motivoRechazo"
                                (input)="habilitarBotonObservaciones(motivoRechazo)">
                      </textarea>
                    </mat-form-field>
                    <br>
                    <button *ngIf="activarRechazar"
                            (click)="actualizarEstadoSolicitud(solicitud._id, iAppOfertas.estado_5.number, false, iAppOfertas.estado_5.name, true, motivoRechazo)"
                            mat-raised-button
                            color="accent"
                            [disabled]="!habilitarEnviarObservacion">
                      Anular
                    </button>
                    <button *ngIf="!activarRechazar" mat-raised-button color="warn" disabled>
                      Anular
                    </button>
                  </section>
                </mat-card-actions>
              </mat-card>
            </div>
          </div>
          
          <button class="my-carousel-arrow next" 
                  (click)="nextSlide()" 
                  [disabled]="currentSlide === 3"
                  matTooltip="Sección siguiente">
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="true" [disabled]="true" class="compact-panel">
        <mat-expansion-panel-header class="clasico">
          <mat-panel-title class="card-title-large">Descripción</mat-panel-title>
        </mat-expansion-panel-header>
        <mat-card-content>
          <app-detalle [actividad]="actividad" [nombrePais]="nombrePais"></app-detalle>
        </mat-card-content>
      </mat-expansion-panel>

      
    </div>
  </div>
</div>